module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-8-acf7bb89d67447a89475600452930e78.jpg";